@if (buttonVisible() && enabled()) {
    <div class="flex gap-4">
        <button
            mat-stroked-button
            id="form-nav-btn"
            class="form-nav-btn"
            title="Cancel and Return"
            (click)="cancelAndReturn()"
            [disabled]="saving()">
            <mat-icon [svgIcon]="'mat_outline:exit_to_app'"></mat-icon>
            <!-- <mat-icon [svgIcon]="'feather:x'"></mat-icon> -->
            <span class="nav-menu-hidden-text">{{ cancelButtonText() }}</span>
        </button>
        <button
            mat-stroked-button
            id="form-nav-btn"
            class="form-nav-btn"
            title="Save and Return"
            (click)="saveAndReturn()"
            [disabled]="saving()">
            @if (saving()) {
                <mat-spinner diameter="20"></mat-spinner>
            }
            @else {
                <mat-icon [svgIcon]="'feather:save'"></mat-icon>
                <!-- <mat-icon [svgIcon]="'mat_outline:exit_to_app'"></mat-icon> -->
            }
            <span class="nav-menu-hidden-text">{{ saveButtonText() }}</span>
        </button>
    </div>
}
